// extracted by mini-css-extract-plugin
export default {"container":"result_container__ZULVa","videoWrapper":"result_videoWrapper__zIDeO","btn":"result_btn__XRWuE","items":"result_items__c+T2X","item":"result_item__u+N-A"};